import {FC, useCallback} from "react";
import MenuItem from "@mui/material/MenuItem";
import TableCell from "@mui/material/TableCell";
import MuiTableRow from "@mui/material/TableRow";
import {GroupMembership} from "@memaro/api";
import {AdminGroupID, ViewerGroupID} from "../../../constants/groups.ts";
import {SelectChangeEvent} from "@mui/material/Select/SelectInput";
import IconButton from "@mui/material/IconButton";
import DeleteIcon from "@mui/icons-material/Delete";
import InlineSelect from "@memaro/components/InlineSelect.tsx";
import { useAuth } from "../../../lib/auth.ts";
import {useFeedback} from "@memaro/feedback";

export type TableRowProps = {
    row: GroupMembership;
    onUpdate: (membership: GroupMembership) => void;
    updating: boolean
    onDelete: (membership: GroupMembership) => void;
    deleting: boolean;
}

const TableRow: FC<TableRowProps> = ({row, onUpdate, updating, onDelete, deleting}) => {
    const {username} = useAuth()
    const {confirm} = useFeedback()

    const handleChangeGroup = useCallback((e: SelectChangeEvent) => {
        onUpdate({
            ...row,
            groupIDs: [e.target.value]
        })
    }, [onUpdate, row]);

    const handleDelete = useCallback(
        async () => {
            if (await confirm?.(`Weet u zeker dat u ${row.username} toegang wil ontzeggen van deze herinneringspagina?`)) {
                onDelete(row)
            }
        },
        [onDelete, row, confirm]
    );

    return (
        <MuiTableRow>
            <TableCell component="th" scope="row">
                {row.username}
            </TableCell>
            <TableCell padding="none">
                <InlineSelect value={row.groupIDs[0]} onChange={handleChangeGroup} disabled={deleting || updating || row.username == username}>
                    <MenuItem value={ViewerGroupID}>Bekijk</MenuItem>
                    <MenuItem value={AdminGroupID}>Beheer</MenuItem>
                </InlineSelect>
            </TableCell>
            <TableCell align="right" padding="none">
                <IconButton color="primary" onClick={handleDelete} disabled={updating || row.username == username} loading={deleting}>
                    <DeleteIcon/>
                </IconButton>
            </TableCell>
        </MuiTableRow>
    )
}

export default TableRow
